export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const SHOPIFY_URL = process.env.REACT_APP_SHOPIFY_URL;

export const billingPolicyIntervals = {
  DAY: '日間隔',
  WEEK: '週間間隔',
  MONTH: 'ヶ月間隔',
  YEAR: '年間隔',
};
